export default function DatenschutzV2() {
  return (
    <div className="min-h-screen text-[var(--text)]">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white/85 backdrop-blur-sm rounded-2xl p-6 shadow-sm space-y-4 text-sm">
        <h1 className="text-2xl font-semibold mb-2">Datenschutz</h1>
        <p className="text-[var(--muted)]">
          Diese Seite beschreibt in vereinfachter Form, wie wir bei CarmaCircle mit Deinen Daten umgehen.
        </p>

        <div className="space-y-1">
          <h2 className="text-sm font-medium">1. Verantwortliche Stelle</h2>
          <p>Daniel Sesay</p>
          <p>60389 Frankfurt</p>
          <p>
            E-Mail: <a href="mailto:beta@carmacircle.org" className="underline">beta@carmacircle.org</a>
          </p>
        </div>

        <div className="space-y-1">
          <h2 className="text-sm font-medium">2. Welche Daten verarbeiten wir?</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>E-Mail-Adresse und Name (falls angegeben) zur Erstellung Deines Kontos.</li>
            <li>Anmeldeinformationen (z.&nbsp;B. Login-Zeitpunkt) zur Sicherung des Zugangs.</li>
            <li>Inhalte von Carma-Nachrichten, die Du sendest oder empfängst.</li>
          </ul>
        </div>

        <div className="space-y-1">
          <h2 className="text-sm font-medium">3. Wofür nutzen wir die Daten?</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Um Dir den Login und die Nutzung von CarmaCircle zu ermöglichen.</li>
            <li>Um Carma-Nachrichten zwischen registrierten Nutzer:innen bereitzustellen.</li>
            <li>Um die Stabilität und Sicherheit des Systems zu überwachen.</li>
          </ul>
        </div>

        <div className="space-y-1">
          <h2 className="text-sm font-medium">4. Speicherdauer</h2>
          <p>
            Wir speichern Daten nur so lange, wie es für den Betrieb von CarmaCircle notwendig ist.
          </p>
        </div>

        <div className="space-y-1">
          <h2 className="text-sm font-medium">5. Deine Rechte</h2>
          <p>
            Du hast das Recht, Auskunft über Deine gespeicherten Daten zu erhalten, Daten berichtigen
            oder löschen zu lassen oder der Verarbeitung zu widersprechen, soweit dem keine rechtlichen Pflichten
            entgegenstehen.
          </p>
          <p>
            Wende Dich dafür bitte an{' '}
            <a href="mailto:beta@carmacircle.org" className="underline">
              beta@carmacircle.org
            </a>
            .
          </p>
        </div>

        <p className="text-[var(--muted)] text-xs pt-2">
          Hinweis: Diese Informationen ersetzen keine vollumfängliche Datenschutz-Erklärung. Sie dienen dazu, Dir
          einen transparenten Überblick zu geben.
        </p>
        </div>
      </div>
    </div>
  );
}
